import React, { FunctionComponent } from 'react';
import { Icon, SemanticCOLORS } from 'semantic-ui-react';

type ProViewZoneProps = {
  status: string;
  mainCityCode: string;
};

const statusColor = (status: string): SemanticCOLORS =>
  status === 'published' ? 'green' : status === 'draft' ? 'red' : 'grey';

/**
 * A view of a presentation by its zone, with the dot of the zones of a pro page: green
 * published, red draft, grey archived. An archived view is struck through: the review is not
 * shown there.
 */
export const ProViewZone: FunctionComponent<ProViewZoneProps> = ({
  status,
  mainCityCode,
}) => (
  <span style={{ whiteSpace: 'nowrap' }}>
    <Icon
      name="circle"
      size="small"
      color={statusColor(status)}
      style={{ margin: '0 2px 0 0' }}
    />
    {status === 'archived' ? (
      <s style={{ color: '#a0a0a0' }}>{mainCityCode}</s>
    ) : (
      mainCityCode
    )}
  </span>
);

export const ProViewZones: FunctionComponent<{
  proViews: {
    id: number;
    status: string;
    bilikZone: { mainCityCode: string };
  }[];
}> = ({ proViews }) => {
  const order = ['published', 'draft', 'archived'];
  const sorted = [...proViews].sort(
    (a, b) => order.indexOf(a.status) - order.indexOf(b.status),
  );
  return (
    <>
      {sorted.map((proView, index) => (
        <React.Fragment key={proView.id}>
          {index > 0 ? ' · ' : null}
          <ProViewZone
            status={proView.status}
            mainCityCode={proView.bilikZone.mainCityCode}
          />
        </React.Fragment>
      ))}
    </>
  );
};

export const ProViewZonesLegend: FunctionComponent = () => (
  <p style={{ color: '#767676', fontSize: '0.85em' }}>
    <ProViewZone status="published" mainCityCode="publiée" />
    {' · '}
    <ProViewZone status="draft" mainCityCode="brouillon" /> : visible à sa
    publication{' · '}
    <ProViewZone status="archived" mainCityCode="archivée" /> : non visible
  </p>
);
